import React from "react";
import { FaFacebookF, FaInstagram, FaYoutube, FaTwitter } from "react-icons/fa";
import "./Home.css";

function Footer() {
  return (
    <footer className="home-footer">
      <div className="footer-content">
        <span>&copy; {new Date().getFullYear()} Periyar Writings. All rights reserved.</span>
        <div className="footer-social">
          <a href="https://www.instagram.com/periyar_writings?utm_source=qr&igsh=eDJ1ZXM0Z2YzNDZw" className="footer-icon" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <FaInstagram />
          </a>
          <a href="https://www.facebook.com/share/1FtNSJquyo/" className="footer-icon" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <FaFacebookF />
          </a>
          <a href="https://youtube.com/@periyarscreen?si=q_PpOLiNAXPMhe5A" className="footer-icon" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
            <FaYoutube />
          </a>
          <a href="https://x.com/Periyarwritings" className="footer-icon" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
            <FaTwitter />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
